import { render, staticRenderFns } from "./ToiletBoxListItem.vue?vue&type=template&id=5f872dd7&scoped=true&lang=pug"
import script from "./ToiletBoxListItem.vue?vue&type=script&lang=ts"
export * from "./ToiletBoxListItem.vue?vue&type=script&lang=ts"
import style0 from "./ToiletBoxListItem.vue?vue&type=style&index=0&id=5f872dd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f872dd7",
  null
  
)

export default component.exports